export const DEBT = {
  nickname: 'PRODUCTS.DEBT.shortname',
  isHidden: true,
  icon:'debt'
};
